<template>
    <div class="d-flex align-items-center flex-column flex-md-row p-2 p-md-5">
        <div class="overlay__img--wrapper">
            <img src="@/assets/milestones/milestone__2006.jpg" class="img-fluid overlay__img">
        </div>
        <div class="milestone__info--overlay">
            <div class="milestone__year font-24 text-left">2006</div>
            <div class="milestone__headline font-bold font-32 text-left" v-html="$t('MILESTONE_2006_HEADLINE')">Life Quality Beauty Centre</div>
            <div class="text-left d-flex flex-column align-items-start mt-3 mt-md-5">
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_2006_TEXT_01')">
                    In some countries Shiseido has set up special facilities, that are free of charge and non-profit
                    making, to help people who suffer from extreme or rare skin conditions, that effect their everyday
                    lives. These clinics are in association with hospitals and doctors, and offer practical advice on
                    how to live with such conditions and how to improve not only the appearance of the condition, but
                    helps with the confidence of the people attending to face their everyday life.
                </div>
            </div>
            <div class="text-left d-flex flex-column align-items-center align-items-md-start mt-4 hide-es">
                <div class="milestone__text font-18 mt-4">
                    <a href="https://corp.shiseido.com/slqm/en/salon/voice.html" target="_blank" class="btn btn-red" v-html="$t('MILESTONE_2006_TEXT_02')">Listen to the experiences<br> of the patients</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "milestone-2006",
    }
</script>

<style scoped>

</style>